import { savePageSize, getPageSize } from '@/components/table/helpers/pageSize'
import { POSTFIX_PAGESIZE, PREFIX_DEFAULT } from '@/components/table/helpers/tablePrefixes'

const map = new Map()

export default {
  data() {
    return {
      page: 1,
      rows: [],
      pageSize: 10,
      total: 0,
      sort: [],
      isLoading: false,
    }
  },
  computed: {
    tableLSId() {
      return PREFIX_DEFAULT + this.storageId + POSTFIX_PAGESIZE
    },

    paginationListeners() {
      return {
        'on-page-number-change': this.pageNumberChange,
        'on-page-size-change': this.pageSizeChange,
        'sort-change': this.sortChange,
      }
    },
  },
  watch: {
    pageSize: {
      handler: function (size) {
        savePageSize.apply(this, [this.tableLSId, size])
      },
    },
  },
  mounted() {
    this.pageSize = getPageSize.call(this, this.tableLSId)
  },
  beforeDestroy() {
    map.clear()
  },
  methods: {
    /**
     * Set parameter `page`.
     * */
    pageNumberChange(number) {
      this.page = number

      // Not update query params.
      if (this.paginationUpdateLocaly) return

      return this.updateQueryParams({
        query: { ...this.$query, page: number, pageSize: this.pageSize },
      })
    },

    /**
     * Set `page` and `pageSize`.
     * */
    pageSizeChange(size) {
      this.page = 1
      this.pageSize = size

      // Not update query params.
      if (this.paginationUpdateLocaly) return

      return this.updateQueryParams({ query: { ...this.$query, page: 1, pageSize: size } })
    },

    /**
     * Set component parameter `sort`.
     * Then this parameter will be sync with url query parameter.
     * */
    sortChange(params) {
      this.buildParamsMap(params)

      const res = []
      map.forEach((value, key) => res.push(`${key}.${value}`))

      this.sort = res
    },

    buildParamsMap(params) {
      return Object.keys(params).forEach((key) => {
        if (params[key]) map.set(key, params[key])
        else map.delete(key)
      })
    },
  },
}
